import { HStack, Text } from '@chakra-ui/react';
import { WarningCircleIcon } from '@phosphor-icons/react';

type FieldErrorProps = {
  error?: string;
};

export const FieldError = ({ error }: FieldErrorProps) => {
  if (!error) return null;

  return (
    <HStack
      gap={1.5}
      mt={1.5}
      color="red.500"
      align="flex-start"
      css={{
        animation: 'fieldErrorSlideIn 0.2s ease-out',
      }}
    >
      <WarningCircleIcon
        size={14}
        weight="fill"
        style={{ flexShrink: 0, marginTop: 1 }}
      />
      <Text textStyle="xs" fontWeight="medium" lineHeight="short">
        {error}
      </Text>
    </HStack>
  );
};
